<div ngbAccordion #acc="ngbAccordion" [closeOthers]="true" [animation]="true">
  <div ngbAccordionItem [ngbAccordionItem]="'custom-panel-' + index + carrouselItem.id" [collapsed]="!item.isSelected">
    <div ngbAccordionHeader>
      <div class="card-header carrousel-card-header carrousel-accordion-icon mr-1">
        <button
          ngbAccordionButton
          (click)="select(item.cid); (false)"
          [attr.data-e2e]="e2e + index + '-' + carrouselItem.id"
          class="border-0 item-container no-border-bottom"
          [class.carrousel-active-navigation-item]="item.isSelected && selectedLink === ''"
          [class.carrousel-active-navigation]="item.isSelected && !carrouselLinksItemsSelected"
          [class.carrousel-inactive-navigation]="!item.isSelected || carrouselLinksItemsSelected"
        >
          <div
            class="accordion-card-title"
            [ngClass]="
              item.city || item.phoneNumber ? 'carrousel-accordion-card-subtitle' : 'carrousel-accordion-card-title'
            "
          >
            <div class="d-flex flex-column">
              <div class="d-flex flex-row">
                <div
                  class="align-self-center carrousel-accordion-icon accordion-icon mr-1"
                  [class.d-none]="carrouselItem.id === 'SHAREDSERVICES'"
                  aria-hidden="true"
                ></div>
                <span
                  class="align-self-center accordion-title"
                  [class.pl-2]="carrouselItem.id === 'SHAREDSERVICES'"
                  [attr.aria-label]="item.offerName + ' de ' + carrouselItem.button.label"
                >
                  {{ item.offerName }}
                </span>
                @if (getIcon() && getIcon().includes('orange')) {
                  <img class="align-self-center carrousel-orange-small-logo ml-1" [src]="getIcon()" alt="" />
                }
                @if (getIcon() && getIcon().includes('sosh')) {
                  <img class="align-self-center ob1-small-logo ml-1" [src]="getIcon()" alt="" />
                }
              </div>
              <div class="d-flex flex-row">
                <div class="carrousel-empty-space"></div>
                @if (item.city) {
                  <span class="carrousel-accordion-subtitle pl-1">
                    {{ item.city }}
                  </span>
                }
                @if (item.phoneNumber) {
                  <span class="carrousel-accordion-subtitle pl-1">
                    {{ item.phoneNumber }}
                  </span>
                }
              </div>
            </div>
          </div>
        </button>
      </div>
    </div>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody class="accordion">
        <ng-template>
          <div class="accordion-card-body card-body standard mb-1">
            <ul class="items-list carrousel-navigation-item mr-1">
              @for (navItem of item.navigation; track navItem; let idx = $index) {
                <li>
                  <a
                    class="d-block"
                    role="link"
                    [attr.data-e2e]="e2e + idx + '-' + carrouselItem.button.label"
                    [href]="navItem.button.link | link"
                    [attr.aria-label]="navItem.label + ' de ' + item.offerName + ' de ' + carrouselItem.button.label"
                    (click)="openLink(navItem); (false)"
                  >
                    <div
                      class="item-container no-border-bottom pl-1"
                      [class.carrousel-active-navigation-item]="
                        navItem.type === selectedLink.toUpperCase() &&
                        item.isSelected &&
                        (!selectedUsageCode() || navItem.usageCode === selectedUsageCode())
                      "
                    >
                      <div class="item-text carrousel-navigation-label">
                        <div>
                          {{ navItem.label }}
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              }
            </ul>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
